module.exports = __webpack_public_path__ + "img/sleeve lower flounce opening.d14702eb.png";